import ActivityManager from "@/activity/ActivityManager";
import FormsLoader from "@/components/forms/FormsLoader";
import {startChatBot} from "@/components/chatBot/ChatBotTools";

const ActivityList = () => require("@/components/forms/ActivityList");
const ActivityEdit = () => require("@/components/forms/ActivityEdit");


/**
 @@action {
    name: "Run Silena"
    patterns: "Chat with Silena", "Hi", "Let's talk", "Silena", "Good morning", "Good afternoon", "Good evening", "Hello", "How are you", "Can you help", "Can we talk", "Start chat", "Start bot", "Run chatbot", "talk to chat-bot"
    icon: "user"
    fromChat: false
  }

 @returns {Promise<void>}
 */
export async function runSilena(){
    await startChatBot();
}

